package fyi.moko.hotpl.domain.model

/** Longest name a user may give an emotion slot — chips must still fit two per row. */
const val EMOTION_LABEL_MAX_LENGTH = 16

/**
 * The name to show for this emotion: the user's override from
 * [fyi.moko.hotpl.domain.service.EmotionLabelPreference] when present, else the palette default.
 */
fun Emotion.displayLabel(overrides: Map<String, String>): String =
    overrides[id]?.let { normalizeEmotionLabel(it) } ?: label

/**
 * Collapses what the user typed into a storable name: trimmed, capped at
 * [EMOTION_LABEL_MAX_LENGTH], and null when nothing usable is left (blank = "use the default").
 */
fun normalizeEmotionLabel(raw: String?): String? =
    raw?.trim()?.take(EMOTION_LABEL_MAX_LENGTH)?.takeIf { it.isNotEmpty() }
